import React, { MouseEventHandler } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Action, Category } from "constants/events";
import { useEventTracker } from "hooks/useEventTracker";
import { REQUEST_LOCATION } from "redux/reducers/location";
import {
  getIsValidStreetAddress,
  getLocationState,
} from "redux/selectors/location";

import ChevronIcon from "components/Icons/ChevronIcon";
import TrackImpression from "components/TrackImpression";

const FulfillmentInfoBanner = () => {
  const modalReturnRef = React.createRef<HTMLButtonElement>();
  const location = useSelector(getLocationState);
  const isValidAddress = useSelector(getIsValidStreetAddress);
  const { trackEvent } = useEventTracker();
  const dispatch = useDispatch();

  const handleClick: MouseEventHandler = (ev) => {
    ev.preventDefault();
    trackEvent(Category.unifiedShoppingExperience, Action.click, "address bar");
    dispatch({ type: REQUEST_LOCATION });
  };

  return (
    <div className="w-full">
      <TrackImpression
        category={Category.unifiedShoppingExperience}
        label="address bar"
      >
        <div className="flex items-center justify-center text-center text-sm py-md bg-leafly-white">
          <span className="pr-[5px] mt-1">Shopping near</span>
          <button
            onClick={handleClick}
            ref={modalReturnRef}
            className="text-sm text-left underline mt-1"
            data-testid="delivery-validation-btn-info-bar"
          >
            {isValidAddress && location.street
              ? `${location.street.number} ${location.street.name}`
              : `${location.formattedLocation}`}
            <ChevronIcon className="inline ml-1" width="16" height="16" />
          </button>
        </div>
      </TrackImpression>
    </div>
  );
};

export default FulfillmentInfoBanner;
